module.exports = __webpack_public_path__ + "img/icon17.e51a47a8.png";